module.exports = __webpack_public_path__ + "static/media/csplogo.74134b8b.png";